import React from 'react';
import { Icon } from '../../Icons/Icons';
import { SelectItem, SelectItemCheckMarkContainer } from './style';

export const CheckMark = () => (
    <Icon.Box size={'16x16'}>
        <Icon.CheckOrange />
    </Icon.Box>
);

export const SelectItemComponent = ({ onClick, isChecked, checkMark, children }) => {
    const CheckMark = checkMark;
    return (
        <SelectItem onClick={onClick}>
            <SelectItemCheckMarkContainer>{isChecked && <CheckMark />}</SelectItemCheckMarkContainer>
            {children}
        </SelectItem>
    );
};



// WEBPACK FOOTER //
// ./src/UI/Components/Items/SelectItems/SelectItemComponent.js